import { useEffect, useRef, useState } from 'react';
import { motion, useScroll } from 'framer-motion';
import TextAreaPart3 from 'section3/textAreas/TextAreaPart3';
import classNames from 'classnames';

const Part3 = () => {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  });

  useEffect(() => {
    return scrollYProgress.onChange((latest) => {
      setActive(latest > 0);
    });
  }, [scrollYProgress]);
  return (
    <div ref={ref} className='relative grid grid-cols-12 gap-1 pb-20 lg:pb-40'>
      <div className='col-span-12 md:col-span-6'>
        <TextAreaPart3 active={active} />
      </div>
      <div className='col-span-12 md:col-start-8 md:col-span-5 mt-6 md:mt-0 '>
        <img
          src='./images/s3images/part3pic.png'
          alt='pic'
          className='lg:w-3/4 '
        />
      </div>
      <div
        className={classNames(
          'hidden z-10 absolute left-[48%] -top-4  w-16 h-16 rounded-full md:flex items-center justify-center',
          { 'bg-primary': active },
          { 'bg-primary-lightest': !active }
        )}
      >
        <svg
          width='38'
          height='38'
          viewBox='0 0 38 38'
          xmlns='http://www.w3.org/2000/svg'
          className={classNames(
            'h-8',
            { 'fill-white': active },
            { 'fill-primary': !active }
          )}
        >
          <path d='M23.4162 25.875C23.3462 26.2442 23.2727 26.6047 23.1939 26.9582C22.1982 27.2603 21.3258 27.8745 20.7057 28.7102C20.0856 29.5458 19.7505 30.5586 19.7499 31.5992V31.7795C19.7499 32.5932 19.8969 33.407 20.2049 34.1787C19.4979 35.0292 18.7472 35.4965 17.9999 35.4965C15.9052 35.4965 13.7982 31.832 12.6834 26.3895L12.5819 25.875H23.4162ZM23.2499 22.375C23.2499 21.2305 23.5649 20.1595 24.1109 19.2425C24.1538 17.6607 24.114 16.0777 23.9919 14.5H12.0062L11.9484 15.3558C11.7963 17.9889 11.8736 20.6303 12.1794 23.25H23.3129C23.2712 22.9602 23.2501 22.6678 23.2499 22.375ZM29.3749 16.25C30.7183 16.2503 32.0243 16.6921 33.0921 17.5072C34.1599 18.3223 34.9303 19.4657 35.2847 20.7615C35.6141 18.6831 35.569 16.5625 35.1517 14.5H26.6292L26.6974 15.6497C26.7149 16.0452 26.7289 16.4425 26.7394 16.845C27.5374 16.4635 28.4317 16.25 29.3749 16.25ZM2.3637 25.8767H9.8992C10.5379 29.5202 11.6194 32.6212 13.0352 34.7895C8.58644 33.4688 4.84193 30.4397 2.62095 26.365L2.3637 25.8767ZM0.846447 14.5018H9.36895C9.18583 17.0776 9.20513 19.6639 9.4267 22.2367L9.5282 23.2517H1.29795C0.41157 20.4199 0.256248 17.4098 0.846447 14.5018ZM23.1519 1.50975L22.9629 1.21225C25.5641 1.98426 27.9507 3.34895 29.9354 5.19908C31.92 7.04921 33.4486 9.33437 34.4009 11.875H26.3649C25.8119 7.647 24.6902 4.014 23.1502 1.50975H23.1519ZM12.8199 1.277L13.0334 1.21225C11.4934 3.57475 10.3472 7.038 9.7382 11.1068L9.63145 11.8768H1.59895C2.5374 9.37119 4.03633 7.11337 5.98115 5.27593C7.92597 3.43848 10.2652 2.07005 12.8199 1.27525V1.277ZM17.9999 0.503502C20.3064 0.503502 22.6287 4.952 23.6244 11.3238L23.7049 11.875H12.2949C13.2399 5.20925 15.6269 0.503502 17.9999 0.503502ZM33.7499 22.375C33.7499 23.5353 33.289 24.6481 32.4685 25.4686C31.6481 26.2891 30.5353 26.75 29.3749 26.75C28.2146 26.75 27.1018 26.2891 26.2814 25.4686C25.4609 24.6481 24.9999 23.5353 24.9999 22.375C24.9999 21.2147 25.4609 20.1019 26.2814 19.2814C27.1018 18.4609 28.2146 18 29.3749 18C30.5353 18 31.6481 18.4609 32.4685 19.2814C33.289 20.1019 33.7499 21.2147 33.7499 22.375ZM37.2499 31.7812C37.2499 34.5042 34.9994 37.25 29.3749 37.25C23.7504 37.25 21.4999 34.5147 21.4999 31.7812V31.601C21.4999 29.886 22.8894 28.5 24.6027 28.5H34.1472C35.8622 28.5 37.2499 29.8877 37.2499 31.601V31.7812Z' />
        </svg>
      </div>
      <div className='hidden md:block bg-gradient-to-b from-white to-primary-lightest w-1 absolute md:left-[52%] lg:left-1/2  top-8 h-[calc(100%_-_3rem)] z-0'></div>
      <motion.div
        className='hidden md:block  w-1  absolute bg-primary md:left-[52%] lg:left-1/2 top-8 h-[calc(100%_-_3rem)] z-10 origin-top	'
        style={{ scaleY: scrollYProgress }}
      />
    </div>
  );
};

export default Part3;
